import { render } from "./LearningHubIsland.vue?vue&type=template&id=33e27254"
import script from "./LearningHubIsland.vue?vue&type=script&lang=js"
export * from "./LearningHubIsland.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__